import { UiSchema, WidgetProps } from '@rjsf/utils';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';
import { DynamicFormAutocomplete } from '../shared/dynamic-form-autocomplete';
import { DynamicFormImageUpload } from '../shared/dynamic-form-image-upload';
import { DAYS } from './cron-converter';

const uiGrid: UIGridElement[] = [
  { fields: { name: 8, type: 4 } },
  { fields: { parent: 8, shortcode: 4 } },
  { fields: { senderID: 6 } },
  { fields: { image: 12 } },
  { title: 'Location', fields: { addressLine1: 12 } },
  { fields: { addressLine2: 12 } },
  { fields: { suburb: 6, postcode: 3, state: 3 } },
  { fields: { country: 6, timezone: 6 } },
  {
    title: 'UI Features',
    fields: { showDeliveries: 6, showOrders: 6, allowPersonalInfo: 6, enableInventoryBookingFlow: 6 }
  },
  {
    title: 'Overdue Period and Reminders',
    notice: {
      isEnabledPredicate: (formData: Record<string, any>) => formData.isManagedByAc,
      title: 'Managed by AC',
      notice: 'This project is managed by AC. Settings changed here may also need to be updated in the AC portal.',
      severity: 'warning'
    },
    fields: {
      overduePeriod: 6,
      reminderPeriod: 6
    }
  },
  { fields: { ...DAYS.reduce((acc, day) => ({ ...acc, [day]: 6 }), {}) } }
];

const carrierUiGrid: UIGridElement[] = [
  { fields: { name: 8, type: 4 } },
  { fields: { status: 4 } },
  { fields: { parent: 8, shortcode: 4 } },
  { fields: { image: 12 } }
];

const regionUiGrid: UIGridElement[] = [
  { fields: { name: 8, type: 4 } },
  { fields: { parent: 8, shortcode: 4 } },
  { fields: { status: 4 } }
];

export const projectSettingsFormUISchema: UiSchema = {
  'ui:submitButtonOptions': {
    norender: true
  },
  name: {
    'ui:classNames': 'project-name-input'
  },
  'ui:field': 'custom',
  'ui:grid': uiGrid,
  'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
  // Sets a custom widget for the parent field
  parent: {
    'ui:widget': (props: WidgetProps) => {
      return <DynamicFormAutocomplete {...props} />;
    }
  },
  image: {
    'ui:options': { showPreview: true, buttonLabel: 'Upload logo' },
    'ui:widget': (props: WidgetProps) => {
      return <DynamicFormImageUpload {...props} />;
    }
  }
};

export const carrierProjectSettingsFormUISchema: UiSchema = {
  ...projectSettingsFormUISchema,
  'ui:grid': carrierUiGrid
};

export const regionProjectSettingsFormUISchema: UiSchema = {
  ...projectSettingsFormUISchema,
  'ui:grid': regionUiGrid
};
